<!-- eslint-disable vue/multi-word-component-names -->
<template>
    <v-container>
        <h2>Settings</h2>
        <v-card class="pa-9 mt-3">

            <v-row>
                <v-col cols="12" lg="6" md="6" sm="12" style="padding: 0 !important;">
                    <div class="d-flex align-center">
                        <v-icon>mdi-account-circle-outline</v-icon>
                        <h3>&nbsp; Account</h3>
                    </div>
                    <span class="descriptionColor mt-2">View your account settings and change it later.</span>
                </v-col>
                <v-col cols="12" lg="6" md="6" sm="12" style="padding: 0 !important;">
                    <div class="d-flex align-center justify-end mt-2">
                        <p>{{ shopDetails.shop_owner }}</p>
                        <v-btn class="ms-5" size="small" @click="openAccountDialog" icon>
                            <v-icon class="descriptionColor">mdi-chevron-right</v-icon>
                        </v-btn>
                    </div>
                </v-col>
            </v-row>

            <v-divider class="my-6"></v-divider>

            <v-row>
                <v-col cols="12" lg="6" md="6" sm="12" style="padding: 0 !important;">
                    <div class="d-flex align-center">
                        <v-icon>mdi-store-outline</v-icon>
                        <h3>&nbsp; Store</h3>
                    </div>
                    <span class="descriptionColor mt-2">View your store settings and change it later.</span>
                </v-col>
                <v-col cols="12" lg="6" md="6" sm="12" style="padding: 0 !important;">
                    <div class="d-flex align-center justify-end mt-2">
                        <p>{{ shopDetails.shop_name }}</p>
                        <v-btn class="ms-5" size="small" @click="openShopDialog" icon>
                            <v-icon class="descriptionColor">mdi-chevron-right</v-icon>
                        </v-btn>
                    </div>
                </v-col>
            </v-row>

            <v-divider class="my-6"></v-divider>

            <v-row>
                <v-col cols="12" lg="6" md="6" sm="12" style="padding: 0 !important;">
                    <div class="d-flex align-center">
                        <v-icon>mdi-theme-light-dark</v-icon>
                        <h3>&nbsp; Theme</h3>
                    </div>
                    <span class="descriptionColor mt-2">Select your preferred theme and change it later.</span>
                </v-col>
                <v-col cols="12" lg="6" md="6" sm="12" style="padding: 0 !important;">
                    <div class="d-flex align-center justify-end mt-2">
                        <p>{{ currentThemeName }}</p>
                        <v-btn class="ms-5" size="small" @click="openThemeDialog" icon>
                            <v-icon class="descriptionColor">mdi-chevron-right</v-icon>
                        </v-btn>
                    </div>
                </v-col>
            </v-row>

            <v-divider class="my-6"></v-divider>
        </v-card>

        <ThemeDialog v-model="themeDialog" />

        <ShopEditDialog v-model="shopEditDialog" :shop="currentShop" @update:success="handleUpdateSuccess"
            @update:error="showError" />

        <Alert ref="alertRef" />
        <Snackbar ref="snackbarRef" />
    </v-container>
</template>

<script>
import { useTheme } from 'vuetify';
import { computed } from 'vue';
import { useAuthStore } from '@/stores/auth';
import { useShopStore } from '@/stores/shopStore';
import ThemeDialog from '@/components/Dialogs/ThemeDialog.vue';
import ShopEditDialog from '@/components/Dialogs/ShopEditDialog.vue';
import Alert from '@/components/Alert.vue';
import Snackbar from '@/components/Snackbar.vue';

export default {
    name: 'SettingsPage',
    components: {
        Alert,
        ThemeDialog,
        ShopEditDialog,
        Snackbar
    },
    data() {
        return {
            accountDialog: false,
            storeDialog: false,
            themeDialog: false,
            shopEditDialog: false,
            currentShop: null,
            shopDetails: {},
        }
    },
    setup() {
        const authStore = useAuthStore();
        const theme = useTheme();
        const shopStore = useShopStore();
        const currentThemeName = computed(() => {
            return theme.global.name.value === 'dark' ? 'Dark' : 'Light';
        });

        return {
            authStore,
            theme,
            currentThemeName,
            shopStore,
        };
    },
    mounted() {
        this.fetchShopDetails();
    },
    methods: {

        openAccountDialog() {
            this.accountDialog = true;
        },

        openThemeDialog() {
            this.themeDialog = true;
        },

        openStoreDialog() {
            this.storeDialog = true;
        },

        async openShopDialog() {
            await this.fetchShopDetails();
            this.currentShop = JSON.parse(JSON.stringify(this.shopDetails));
            this.shopEditDialog = true;
        },

        async fetchShopDetails() {
            try {
                const shopId = this.authStore.getShopId;
                if (shopId) {
                    await this.shopStore.fetchShopDetails(shopId);
                    this.shopDetails = this.shopStore.currentShop;
                }
            } catch (error) {
                console.error('Error fetching shop details:', error);
                this.showError(error.message || 'Failed to fetch shop details');
            }
        },

        handleUpdateSuccess(updatedData) {
            if (updatedData) {
                this.shopDetails = { ...this.shopDetails, ...updatedData };
                this.currentShop = { ...this.currentShop, ...updatedData };
            }
        },

        showError(message) {
            this.$refs.snackbarRef.showSnackbar(message, "error");
        },

        showSuccess(message) {
            this.$refs.snackbarRef.showSnackbar(message, "success");
        },
    },
};
</script>

<style scoped>
.descriptionColor {
    color: #a3a3a3;
}

p {
    font-size: clamp(0.9rem, 4vw, 1.2rem);
}

@media (max-width: 600px) {

    h3,
    .v-icon {
        font-size: 16px;
    }

    .descriptionColor {
        font-size: 13px;
    }
}
</style>